import React from 'react';
import ExpertExpertiseList from '../ExpertExpertisePage/components';

export const EditExpertExpertisePage = () => {
  return <ExpertExpertiseList edit />;
};
